import { render, staticRenderFns } from "./TaskActivityView.vue?vue&type=template&id=2449c483&"
import script from "./TaskActivityView.vue?vue&type=script&lang=js&"
export * from "./TaskActivityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports